import React, { useState } from "react";
import AppBody from "../components/AppBody";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import {
  getTrainerProfile,
  updateTrainerProfile,
} from "../../actions/trainer/trainer_profile_action";
import { useEffect } from "react";

const UpdateTrainerProfile = () => {
  const state = useSelector((state) => state.trainerProfileReducer);
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    dispatch(getTrainerProfile());
  }, []);
  const [isSet, setIsSet] = useState(false);
  const navigate = useNavigate();

  const [profile, setProfile] = useState({
    first_name: "",
    last_name: "",
    mobile_no: "",
    email: "",
    base_location: "",
    address: "",
    dob: "",
    mobile_no2: "",
    mobile_no3: "",
    email2: "",
    email3: "",
    aadhar_no: "",
    pan_no: "",
    GSTIN_no: "",
    state_code: "",
    MSME_reg_no: "",
    type_of_enterprise: "",
    address_proof: "",
    category_of_service: "",
    services_rendered: "",
    vat_no: "",
    profile_pic: "",
    experience_over_all: "",
  });

  if (!isSet && state.trainerDetails && state.trainerDetails.first_name) {
    setProfile({ ...state.trainerDetails });
    setIsSet(true);
  }
  console.log("ahow" + state.trainerDetails);
  const onSubmit = (data) => {
    const formData = new FormData();
    if (data.profile_pic) {
      formData.append("profile_pic", data.profile_pic[0]);
    }
    if (data.address_proof) {
      formData.append("address_proof", data.address_proof[0]);
    }
    formData.append("first_name", profile.first_name);
    formData.append("last_name", profile.last_name);
    formData.append("mobile_no", profile.mobile_no);
    formData.append("email", profile.email);
    formData.append("base_location", profile.base_location);
    formData.append("address", profile.address);
    formData.append("dob", profile.dob);
    formData.append("mobile_no2", profile.mobile_no2);
    formData.append("mobile_no3", profile.mobile_no3);
    formData.append("email2", profile.email2);
    formData.append("email3", profile.email3);
    formData.append("aadhar_no", profile.aadhar_no);
    formData.append("pan_no", profile.pan_no);
    formData.append("GSTIN_no", profile.GSTIN_no);
    formData.append("state_code", profile.state_code);
    formData.append("MSME_reg_no", profile.MSME_reg_no);
    formData.append("type_of_enterprise", profile.type_of_enterprise);
    formData.append("category_of_service", profile.category_of_service);
    formData.append("services_rendered", profile.services_rendered);
    formData.append("vat_no", profile.vat_no);
    formData.append("experience_over_all", profile.experience_over_all);
    dispatch(updateTrainerProfile(formData));
  };

  if (state.is_done) {
    navigate("/trainer/profile");
  }
  return (
    <AppBody
      loading={state.loading}
      content={
        <div className="middle-sidebar-left">
          <div className="">
            <div className="card">
              <div className="card-header p-3 w-100 border-0 d-flex rounded-lg">
                <Link to={"/trainer/profile"} className="d-inline-block mt-2">
                  <i className="ti-arrow-left font-sm text-white"></i>
                </Link>
                <h4 className="font-xs text-white fw-600 ml-4 mb-0 mt-2">
                  Update Profile
                </h4>
              </div>
              <div className="card-body  p-4 w-100 border-0 mt-2">
                <form
                  onSubmit={handleSubmit(onSubmit)}
                  enctype="multipart/form-data"
                >
                  <div className="row">
                    <div className="col-lg-4 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          First Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={profile.first_name}
                          onChange={(e) =>
                            setProfile({
                              ...profile,
                              first_name: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {state.errors.first_name
                            ? state.errors.first_name
                            : ""}
                        </span>
                      </div>
                    </div>

                    <div className="col-lg-4 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Last Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={profile.last_name}
                          onChange={(e) =>
                            setProfile({
                              ...profile,
                              last_name: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {state.errors.last_name ? state.errors.last_name : ""}
                        </span>
                      </div>
                    </div>
                    <div className="col-lg-4 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Base Location
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={profile.base_location}
                          onChange={(e) =>
                            setProfile({
                              ...profile,
                              base_location: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {state.errors.last_name ? state.errors.last_name : ""}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-4 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Mobile No
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={profile.mobile_no}
                          onChange={(e) =>
                            setProfile({
                              ...profile,
                              mobile_no: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {state.errors.mobile_no ? state.errors.mobile_no : ""}
                        </span>
                      </div>
                    </div>

                    <div className="col-lg-4 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Mobile No 2
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={profile.mobile_no2 ? profile.mobile_no2 : " "}
                          onChange={(e) =>
                            setProfile({
                              ...profile,
                              mobile_no2: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {state.errors.mobile_no2
                            ? state.errors.mobile_no2
                            : ""}
                        </span>
                      </div>
                    </div>
                    <div className="col-lg-4 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Mobile No 3
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={profile.mobile_no3? profile.mobile_no3 : " "}
                          onChange={(e) =>
                            setProfile({
                              ...profile,
                              mobile_no3: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {state.errors.mobile_no3
                            ? state.errors.mobile_no3
                            : ""}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-4 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Email No
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={profile.email}
                          onChange={(e) =>
                            setProfile({
                              ...profile,
                              email: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {state.errors.email ? state.errors.email : ""}
                        </span>
                      </div>
                    </div>

                    <div className="col-lg-4 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Email 2
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={profile.email2? profile.email2 : " "}
                          onChange={(e) =>
                            setProfile({
                              ...profile,
                              email2: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {state.errors.email2 ? state.errors.email2 : ""}
                        </span>
                      </div>
                    </div>
                    <div className="col-lg-4 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Email 3
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={profile.email3? profile.email3 : " "}
                          onChange={(e) =>
                            setProfile({
                              ...profile,
                              email3: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {state.errors.email3 ? state.errors.email3 : ""}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-4 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Aadhar No
                        </label>
                        <input
                          type="text"
                          className="form-control upper-text"
                          value={profile.aadhar_no}
                          onChange={(e) =>
                            setProfile({
                              ...profile,
                              aadhar_no: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {state.errors.aadhar_no ? state.errors.aadhar_no : ""}
                        </span>
                      </div>
                    </div>

                    <div className="col-lg-4 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Pan No
                        </label>
                        <input
                          type="text"
                          className="form-control upper-text"
                          value={profile.pan_no}
                          onChange={(e) =>
                            setProfile({
                              ...profile,
                              pan_no: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {state.errors.pan_no ? state.errors.pan_no : ""}
                        </span>
                      </div>
                    </div>
                    <div className="col-lg-4 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          GSTIN No
                        </label>
                        <input
                          type="text"
                          className="form-control upper-text"
                          value={profile.GSTIN_no ? profile.GSTIN_no : " "}
                          onChange={(e) =>
                            setProfile({
                              ...profile,
                              GSTIN_no: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {state.errors.GSTIN_no ? state.errors.GSTIN_no : ""}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-4 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          State Code
                        </label>
                        <input
                          type="text"
                          className="form-control upper-text"
                          value={profile.state_code ? profile.state_code : " "}
                          onChange={(e) =>
                            setProfile({
                              ...profile,
                              state_code: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {state.errors.state_code
                            ? state.errors.state_code
                            : ""}
                        </span>
                      </div>
                    </div>

                    <div className="col-lg-4 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          MSME Register No
                        </label>
                        <input
                          type="text"
                          className="form-control upper-text"
                          onChange={(e) =>
                            setProfile({
                              ...profile,
                              MSME_reg_no: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {state.errors.MSME_reg_no
                            ? state.errors.MSME_reg_no
                            : ""}
                        </span>
                      </div>
                    </div>
                    <div className="col-lg-4 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Type Of Enterprise
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={profile.type_of_enterprise}
                          onChange={(e) =>
                            setProfile({
                              ...profile,
                              type_of_enterprise: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {state.errors.type_of_enterprise
                            ? state.errors.type_of_enterprise
                            : ""}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-4 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Date Of Birth
                        </label>
                        <input
                          type="date"
                          className="form-control"
                          value={profile.dob}
                          onChange={(e) =>
                            setProfile({
                              ...profile,
                              dob: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {state.errors.dob ? state.errors.dob : ""}
                        </span>
                      </div>
                    </div>

                    <div className="col-lg-4 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Category Of Services
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={profile.category_of_service}
                          onChange={(e) =>
                            setProfile({
                              ...profile,
                              category_of_service: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {state.errors.category_of_service
                            ? state.errors.category_of_service
                            : ""}
                        </span>
                      </div>
                    </div>
                    <div className="col-lg-4 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Services Rendered
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={profile.services_rendered}
                          onChange={(e) =>
                            setProfile({
                              ...profile,
                              services_rendered: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {state.errors.services_rendered
                            ? state.errors.services_rendered
                            : ""}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-3 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          VAT NO
                        </label>
                        <input
                          type="text"
                          className="form-control upper-text"
                          value={profile.vat_no}
                          onChange={(e) =>
                            setProfile({
                              ...profile,
                              vat_no: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {state.errors.vat_no ? state.errors.vat_no : ""}
                        </span>
                      </div>
                    </div>

                    <div className="col-lg-3 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Experience Over All
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={profile.experience_over_all}
                          onChange={(e) =>
                            setProfile({
                              ...profile,
                              experience_over_all: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {state.errors.experience_over_all
                            ? state.errors.experience_over_all
                            : ""}
                        </span>
                      </div>
                    </div>

                    <div className="col-lg-3 mb-2">
                      <label className="mont-font fw-600 font-xsss">
                        Upload Profile Pic
                      </label>
                      <div class="custom-file">
                        <input
                          type="file"
                          class="custom-file-input"
                          accept=".png, .jpg, .jpeg"
                          {...register("profile_pic")}
                        />
                        <label class="custom-file-label" htmlFor="customFile">
                          Chosose Profile Picture
                        </label>

                        <span className="error-msg">
                          {state.errors.profile_pic
                            ? state.errors.profile_pic
                            : ""}
                        </span>
                      </div>
                    </div>
                    <div className="col-lg-3 mb-2">
                      <label className="mont-font fw-600 font-xsss">
                        Upload Address Proof
                      </label>
                      <div class="custom-file">
                        <input
                          type="file"
                          class="custom-file-input"
                          accept=".png, .jpg, .jpeg"
                          {...register("address_proof")}
                        />
                        <label class="custom-file-label" htmlFor="customFile">
                          Address Proof
                        </label>
                        <span className="error-msg">
                          {state.errors.address_proof
                            ? state.errors.address_proof
                            : ""}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-12 mb-12">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Address
                        </label>
                        <textarea
                          name="description"
                          className="form-control"
                          rows={2}
                          cols={4}
                          value={profile.address}
                          onChange={(e) =>
                            setProfile({
                              ...profile,
                              address: e.target.value,
                            })
                          }
                        ></textarea>
                        <span className="error-msg">
                          {state.errors.address ? state.errors.address : ""}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12 text-center">
                      <input
                        type="submit"
                        name="submit"
                        value="Update"
                        className="btn-common px-5"
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default UpdateTrainerProfile;
